/* Environment settings */
/* DEV is injected at build time from the `flags` block in build.config.js,
   keyed on BUILD_ENV. Edit the value there, not here. The hub bundle makes no
   Tapptic API call, so it has no DEV_API. ENV is per-file, not per environment. */
const DEV = false,                   // for test in "dev" mode (for CTA URL)
    ENV = "DESKTOP";                      // APP-MOBILE || DESKTOP
